import React from 'react';
import { Users, Clock, Shield } from 'lucide-react';
import Button from '../common/Button';

const Hero: React.FC = () => (
  <section className="bg-gradient-to-br from-blue-50 via-white to-indigo-50 pt-16 pb-24">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center max-w-4xl mx-auto">
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-6">
          Seamlessly Connect
          <span className="text-blue-600 block">Roommaster & Xero</span>
        </h1>
        <p className="text-xl text-gray-600 mb-8 leading-relaxed max-w-2xl mx-auto">
          Automate your property management accounting with our powerful integration. 
          Save hours every week and eliminate manual data entry errors.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
          <Button size="lg" className="shadow-lg">
            Get Early Access
          </Button>
          <Button variant="outline" size="lg">
            Learn More
          </Button>
        </div>
        <div className="flex items-center justify-center space-x-8 text-sm text-gray-500">
          <div className="flex items-center">
            <Shield className="w-4 h-4 mr-2" />
            Bank-level security
          </div>
          <div className="flex items-center">
            <Clock className="w-4 h-4 mr-2" />
            2-minute setup
          </div>
          <div className="flex items-center">
            <Users className="w-4 h-4 mr-2" />
            24/7 support
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Hero;